import { __extends } from "tslib";
import { DescribeVpcEndpointServicesRequest, DescribeVpcEndpointServicesResult } from "../models/models_3";
import { deserializeAws_ec2DescribeVpcEndpointServicesCommand, serializeAws_ec2DescribeVpcEndpointServicesCommand, } from "../protocols/Aws_ec2";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Describes available services to which you can create a VPC endpoint.</p>
 *         <p>When the service provider  and the consumer have different accounts  multiple
 *             Availability Zones, and the consumer views the VPC endpoint service information, the
 *             response only includes the common Availability Zones. For example, when the service
 *             provider account uses <code>us-east-1a</code> and <code>us-east-1c</code> and the
 *             consumer uses <code>us-east-1a</code> and us-east-1a and us-east-1b, the response
 *             includes the VPC endpoint services in the common Availability Zone,
 *                 <code>us-east-1a</code>.</p>
 */
var DescribeVpcEndpointServicesCommand = /** @class */ (function (_super) {
    __extends(DescribeVpcEndpointServicesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeVpcEndpointServicesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeVpcEndpointServicesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "EC2Client";
        var commandName = "DescribeVpcEndpointServicesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DescribeVpcEndpointServicesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeVpcEndpointServicesResult.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeVpcEndpointServicesCommand.prototype.serialize = function (input, context) {
        return serializeAws_ec2DescribeVpcEndpointServicesCommand(input, context);
    };
    DescribeVpcEndpointServicesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_ec2DescribeVpcEndpointServicesCommand(output, context);
    };
    return DescribeVpcEndpointServicesCommand;
}($Command));
export { DescribeVpcEndpointServicesCommand };
//# sourceMappingURL=DescribeVpcEndpointServicesCommand.js.map